export default __webpack_public_path__ + "static/welding-hero-e23e9c7b303448f23a1d7d585f48e352.jpg";